import React from 'react'
import {Routes, Route, Outlet, Navigate} from 'react-router-dom'
import About from './pages/Home'
import Resume from './pages/Resume'
import Portfolio from './pages/Portfolio'
import Designs from './pages/Designs'
import Contact from './pages/Contact'
import Dashboard from 'pages/admin/Dashboard'

const PrivateRoutes = () =>{
  const isAuth = true
  return( isAuth ? <Outlet/> : <Navigate to="/" />)
}
const AllRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<About/>}/>
      <Route path='/resume' element={<Resume/>}/>
      <Route path='/portfolio' element={<Portfolio/>}/>
      <Route path='/designs' element={<Designs/>}/>
      <Route path='/contact' element={<Contact/>}/>

      <Route element={<PrivateRoutes/>}>
        <Route path='ahmed/dashboard' element={<Dashboard/>} />
      </Route>
    </Routes>
  )
}

export default AllRoutes